module.exports = __webpack_public_path__ + "static/media/ic_call_cut_filled.865c15f3.svg";